import React from 'react';
import { Router, Route, IndexRoute, useRouterHistory } from 'react-router';
import { createHashHistory } from 'history';

import { MainContainer } from 'App';
import { IndexContainer } from 'Home';
import { ContactContainer } from 'Contact';
import { PortfolioContainer, ProjectContainer } from 'Portfolio';

export const history = useRouterHistory(createHashHistory)({ queryKey: false });

/*
 * Export the router
 *
 * @since 1.0.0
 */

export const Routes = (
  <Router history={ history }>
    <Route component={ MainContainer }>
      <Route path='/'>
        <IndexRoute component={ IndexContainer } />
      </Route>
      <Route path='portfolio'>
        <IndexRoute component={ PortfolioContainer } />
        <Route path=':slug' component={ ProjectContainer } />
      </Route>
      <Route path='contact' component={ ContactContainer } />
    </Route>
  </Router>
);



// WEBPACK FOOTER //
// ./app/src/routes.js